import LoadingScreen from 'components/loading-screen'
import { useEffect, useState } from 'react'
import { useRouteMatch } from 'react-router-dom'
import { useTrivia } from '../../contexts/trivia-context'
import TriviaModal from './components/modal'
import TriviaGame from './components/trivia-game'

const TriviaChallenge = () => {
  const [state, { getTrivias }] = useTrivia()
  const route = useRouteMatch<{ id: string }>()
  const [userAccepted, setUserAccepted] = useState(false)

  useEffect(() => {
    if (!state.trivias) {
      getTrivias()
    }
  }, [state])

  const onAccept = () => {
    gtag('event', 'Click', { event_category: GTM_EVENT_CATEGORY, event_label: 'TRIVIA - Aceptar Jugar Trivia', value: '10' })
    return setUserAccepted(true)
  }

  const trivia = state.trivias && state.trivias.find(({ id }) => id === parseInt(route.params.id, 10))

  if (!trivia) {
    return <LoadingScreen />
  }

  if (!userAccepted) {
    return <TriviaModal trivia={trivia} onAccept={onAccept} />
  }

  return <TriviaGame id={route.params.id} />
}

export default TriviaChallenge
